





































import { CartItem } from '@/models/cart/cart-item'
import {
  AppliedBundleDiscount,
  BundleDiscountWithBrand,
} from '@/services/api/bundle-discount'
import {
  SingleBundleRecommendationParameterCreationPolicy
} from '@/usecases/bundle-recommendation/parameter/creation-policy/impl/single-creation-policy'
import {
  SingleBundleRecommendationParameter
} from '@/usecases/bundle-recommendation/single-parameter'

import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class BundleRecommendation extends Vue {
  @Prop({ required: true })
  cartItemList: CartItem[]

  @Prop({ required: true })
  appliedBundleDiscountList: AppliedBundleDiscount[]

  @Prop({ required: true })
  bundleDiscountList: BundleDiscountWithBrand[]

  /**
   * ポリシーの将来的な交換可能性のためにここで明示的に注入している。
   * 同時に複数のポリシーを使う可能性があれば、このVueコンポーネント自体を（slotやcomposition api等により）可変化すること。
   */
  private get parameterCreationPolicy(): SingleBundleRecommendationParameterCreationPolicy {
    return new SingleBundleRecommendationParameterCreationPolicy(
      this.cartItemList,
      this.appliedBundleDiscountList,
      this.bundleDiscountList
    )
  }

  get parameter(): SingleBundleRecommendationParameter | null {
    return this.parameterCreationPolicy.create().toNullable()
  }
}
